export var QuotationStatus;
(function (QuotationStatus) {
    QuotationStatus[QuotationStatus["Concept"] = 1] = "Concept";
    QuotationStatus[QuotationStatus["Verzonden_naar_klant"] = 2] = "Verzonden_naar_klant";
    QuotationStatus[QuotationStatus["Geen_opdracht"] = 3] = "Geen_opdracht";
    QuotationStatus[QuotationStatus["Opdracht"] = 4] = "Opdracht";
})(QuotationStatus || (QuotationStatus = {}));
